import { InjectionKey } from 'vue';
import { useProject } from './composables/useProject';
import { useProjectSeries } from './composables/useProjectSeries';

type ProjectFunctionsInjection = {
    refetchHasAllocations: () => void;
};

export const projectFunctions = Symbol() as InjectionKey<ProjectFunctionsInjection>;
export const projectSeriesKey = Symbol() as InjectionKey<ReturnType<typeof useProjectSeries>>;
export const projectKey = Symbol() as InjectionKey<ReturnType<typeof useProject>>;
